import axiosInstance from './axiosConfig';

// =========================
// Players - Private/Admin
// =========================

export const getPlayersApi = (params) =>
  axiosInstance.get('/players', { params });

export const getPlayerApi = (id) =>
  axiosInstance.get(`/players/${id}`);

export const createPlayerApi = (payload) =>
  axiosInstance.post('/players', payload);

export const updatePlayerApi = (id, payload) =>
  axiosInstance.put(`/players/${id}`, payload);

// بررسی لحظه‌ای کد ملی (تکراری بودن / عضویت در باشگاه دیگر)
export const lookupPlayerNationalCodeApi = (nationalCode) =>
  axiosInstance.get(`/players/lookup/national-code/${nationalCode}`);

export const exportPlayersApi = (params) =>
  axiosInstance.get('/players/export', { params, responseType: 'blob' });

export const deletePlayerApi = (id) =>
  axiosInstance.delete(`/players/${id}`);

// =========================
// Player Photo
// =========================

export const uploadPlayerPhotoApi = (id, file) => {
  const formData = new FormData();
  formData.append('photo', file);

  return axiosInstance.post(
    `/players/${id}/photo`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

// =========================
// Medical Certificate
// =========================

export const uploadPlayerMedicalCertificateApi = (id, file) => {
  const formData = new FormData();
  formData.append('medicalCertificate', file);

  return axiosInstance.post(
    `/players/${id}/medical-certificate`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

// =========================
// Public Players
// =========================

export const getPublicPlayersApi = (params) =>
  axiosInstance.get('/public/players', { params });

export const getPublicPlayerApi = (id) =>
  axiosInstance.get(`/public/players/${id}`);

export const updatePlayerStatusApi = (id,status)=>
 axiosInstance.patch(
   `/players/${id}/status`,
   {
     status
   }
 );